import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex flex-row items-stretch justify-between w-full" }
const _hoisted_4 = {
  key: 1,
  class: "relative w-full"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "w-full mt-5" }
const _hoisted_7 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center py-5"
}

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")
  const _component_BankDetail = _resolveComponent("BankDetail")
  const _component_Message = _resolveComponent("Message")

  return (_ctx.isBankUpdate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-white text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
        _createVNode(_component_Button, {
          label: "อัปเดตบัญชี",
          onClick: _ctx.btnClickUpdateBank,
          class: "mt-4",
          size: "small"
        }, null, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Toast)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.view === 'form')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isActive)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 'form-'+_ctx.resetKey
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-4! border-[#34513b]! mb-3" }, [
                      _createElementVNode("p", { class: "text-white text-[16px]" }, "⚠️ ฝากขั้นต่ำ 1 บาท"),
                      _createElementVNode("p", { class: "text-white text-[14px]" }, [
                        _createElementVNode("span", { class: "text-red-600" }, "โอนภายใน 10 นาที ตรวจสอบเลขบช.ทุกครั้งก่อนโอน"),
                        _createElementVNode("span", null, " จากนั้นแนบสลิปแล้วกด ยืนยัน ฝากขั้นต่ำ 1 บาท สูงสุด 50,000 บาท")
                      ])
                    ], -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_BankDetail, {
                        isActivate: _ctx.bankAccount.active,
                        loading: _ctx.bankAccount.loading,
                        bank: _ctx.bankAccount.data
                      }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"]),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center w-max" }, [
                        _createElementVNode("svg", {
                          class: "text-gray-800",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            stroke: "currentColor",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 12H5m14 0-4 4m4-4-4-4"
                          })
                        ])
                      ], -1 /* HOISTED */)),
                      _createVNode(_component_BankDetail, {
                        isCopyNumber: true,
                        isActivate: _ctx.bankDeposit.active,
                        loading: _ctx.bankDeposit.loading,
                        bank: _ctx.bankDeposit.data
                      }, null, 8 /* PROPS */, ["isActivate", "loading", "bank"])
                    ]),
                    _createElementVNode("form", {
                      onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)), ["prevent"])),
                      class: "mt-4"
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "bg-[#03610bbf]! border-2! border-[#13ff80] rounded-lg mb-3 p-1" }, [
                        _createElementVNode("p", { class: "text-white text-[12px] py-2" }, "คลิกที่กล่องด้านล่างเพื่อเลือกสลิปการโอนเงินของคุณ จากนั้นคลิก ยืนยัน")
                      ], -1 /* HOISTED */)),
                      _createElementVNode("input", {
                        ref: "fileInputRef",
                        type: "file",
                        accept: "image/*",
                        class: "hidden",
                        onChange: _cache[0] || (_cache[0] = (...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                      (!_ctx.form.imgSlip)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.triggerFilePick && _ctx.triggerFilePick(...args))),
                            onDragover: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.isDragging = true), ["prevent"])),
                            onDragleave: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.isDragging = false), ["prevent"])),
                            onDrop: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                            class: _normalizeClass([_ctx.isDragging ? 'border-gray-400 bg-[#040202d9]' : 'border-gray-300', "flex flex-col items-center justify-center gap-3 h-[280px] w-full border-2 border-dashed rounded-2xl bg-[#040202b3] cursor-pointer transition-colors"])
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("svg", {
                              class: "w-14 h-14 text-gray-300",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "1.8",
                                d: "M12 16V4m0 0L8 8m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
                              })
                            ], -1 /* HOISTED */),
                            _createElementVNode("span", { class: "text-gray-300 text-sm" }, "อัปโหลดสลิป ลากและวางที่นี่", -1 /* HOISTED */)
                          ]), 34 /* CLASS, NEED_HYDRATION */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("img", {
                              src: _ctx.form.imgSlip,
                              alt: "สลิป",
                              class: "w-full max-h-[360px] object-contain rounded-2xl border border-gray-200 bg-white"
                            }, null, 8 /* PROPS */, _hoisted_5),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.clearSlip && _ctx.clearSlip(...args))),
                              "aria-label": "ลบสลิป",
                              class: "absolute top-2 right-2 flex items-center justify-center w-9 h-9 rounded-lg bg-red-600 hover:bg-red-700 text-white shadow-md"
                            }, _cache[11] || (_cache[11] = [
                              _createElementVNode("svg", {
                                class: "size-5",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  stroke: "currentColor",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                                })
                              ], -1 /* HOISTED */)
                            ]))
                          ])),
                      (_ctx.msgErr)
                        ? (_openBlock(), _createBlock(_component_Message, {
                            key: 2,
                            severity: "error",
                            class: "mt-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.msgErr), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_Button, {
                          type: "submit",
                          loading: _ctx.form.btn.loading,
                          disabled: (!_ctx.bankAccount.active) || (!_ctx.bankDeposit.active),
                          label: "ยืนยัน",
                          class: "bg-[#44aa34]! border-0! text-white! w-full! font-bold"
                        }, null, 8 /* PROPS */, ["loading", "disabled"])
                      ])
                    ], 32 /* NEED_HYDRATION */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[14] || (_cache[14] = [
                    _createElementVNode("h2", { class: "text-[#10b981] text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                    _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่น ๆ", -1 /* HOISTED */)
                  ])))
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.view === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-[#10b981] text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                _createVNode(_component_Button, {
                  label: "กลับหน้าหลัก",
                  onClick: _ctx.resetToForm,
                  class: "bg-[#008f2c] border-transparent mt-4"
                }, null, 8 /* PROPS */, ["onClick"])
              ]))
            : _createCommentVNode("v-if", true),
        _createVNode(_component_Toast)
      ]))
}